import { connect } from 'react-redux';

import { updateAndPatchUser } from 'actions/session';
import { getSoundsStatusSelector } from 'selectors/user';

import ToggleSound from './ToggleSound';

const mapStateToProps = state => ({
    enabled: getSoundsStatusSelector(state)?.global,
})

const mapDispatchToProps = dispatch => ({
    onClick: (isSoundEnabled) => dispatch(updateAndPatchUser('settings', { sounds: { global: isSoundEnabled } }))
});

export default connect(mapStateToProps, mapDispatchToProps)(ToggleSound);
